import { useEffect, useRef, useState } from "react";
import { Camera, Image as ImageIcon, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, BACKEND, errMsg } from "@/lib/api";
import { shrink } from "@/components/PhotoPicker";

export const field = "w-full h-11 rounded border border-slate-300 px-3 text-sm bg-white focus:border-[#2563EB] outline-none";
export const fieldAuto = "h-11 rounded border border-slate-300 px-3 text-sm bg-white focus:border-[#2563EB] outline-none";
export const btnRed = "inline-flex items-center justify-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] disabled:bg-slate-300 text-white font-display font-bold px-5 py-2.5 rounded-full transition-colors";
export const btnLine = "inline-flex items-center justify-center gap-2 border-2 border-[#0B1D3A] text-[#0B1D3A] hover:bg-[#0B1D3A] hover:text-white font-display font-bold px-5 py-2 rounded-full transition-colors";
export const dmy = (d) => (d ? d.split("-").reverse().join("/") : "");

export const F = ({ label, children, className = "" }) => (
  <label className={`block text-sm font-semibold text-[#0B1D3A] ${className}`}>{label}<div className="mt-1 font-normal">{children}</div></label>
);

export const AuthImg = ({ path, className, testid }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api.get(path, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [path]);
  return src ? <img src={src} alt="" className={className} data-testid={testid} /> : <div className={`${className} bg-slate-100 animate-pulse`} />;
};

export const pubImg = (path) => `${BACKEND}/api${path}`;

export const AddPhoto = ({ url, onDone, id, max = 1 }) => {
  const ref = useRef(null);
  const cam = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = [...(e.target.files || [])].filter((f) => f.type.startsWith("image/")).slice(0, max);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try { for (const file of files) await api.post(url, { photo: await shrink(file) }); } catch (err) { toast.error(errMsg(err)); }
    onDone();
    setBusy(false);
  };
  const btn = "aspect-square w-full border-2 border-dashed border-[#93C5FD] hover:border-[#2563EB] bg-[#EFF6FF] rounded flex flex-col items-center justify-center gap-1 text-[#0B1D3A] text-[11px] font-bold leading-tight text-center px-1";
  return (
    <>
      <input ref={ref} type="file" accept="image/*" multiple={max > 1} onChange={pick} className="hidden" data-testid={`${id}-input`} />
      <input ref={cam} type="file" accept="image/*" capture="environment" onChange={pick} className="hidden" data-testid={`${id}-camera-input`} />
      {busy ? <div className={btn}><Loader2 className="animate-spin" /> Subiendo…</div> : (<>
        <button type="button" onClick={() => ref.current?.click()} data-testid={id} className={btn}><ImageIcon size={18} /> Subir fotos</button>
        <button type="button" onClick={() => cam.current?.click()} data-testid={`${id}-camera`} className={btn}><Camera size={18} /> Hacer foto</button>
      </>)}
    </>
  );
};
